import { useEffect, useState } from "react";
import { toast } from "sonner";
import { inputCls, primaryBtn } from "@/components/AuthLayout";
import { api, errMsg, kina } from "@/lib/api";

const FIELDS = [
  ["base_fare", "Base fare (K)", "Charged at the start of every trip"],
  ["per_km", "Rate per km (K)", "Multiplied by the estimated road distance"],
  ["min_fare", "Minimum fare (K)", "Short trips never cost less than this"],
  ["driver_fee_pct", "Driver platform fee (%)", "Deducted from each driver's daily earnings"],
  ["company_fee_pct", "Comfort Taxi platform fee (%)", "Charged to Comfort Taxi on fleet fares"],
];

export const SettingsPanel = () => {
  const [form, setForm] = useState(null);
  useEffect(() => {
    api.get("/settings").then((r) => setForm(r.data)).catch(() => {});
  }, []);
  const save = async (e) => {
    e.preventDefault();
    try {
      const body = Object.fromEntries(FIELDS.map(([k]) => [k, Number(form[k])]));
      const { data } = await api.put("/admin/settings", body);
      setForm(data);
      toast.success("Fare settings saved");
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  if (!form) return <div className="h-64 animate-pulse rounded-2xl bg-white" />;
  const sample = Math.max(Number(form.base_fare) + Number(form.per_km) * 10, Number(form.min_fare));
  return (
    <div className="grid gap-6 lg:grid-cols-5">
      <form onSubmit={save} className="space-y-5 rounded-2xl border border-blue-100 bg-white p-6 sm:p-8 lg:col-span-3" data-testid="fare-settings-form">
        {FIELDS.map(([k, l, hint]) => (
          <label key={k} className="block">
            <span className="text-xs font-bold uppercase tracking-widest text-slate-500">{l}</span>
            <input data-testid={`fare-${k.replace(/_/g, "-")}-input`} type="number" step="0.01" min="0" required className={`${inputCls} mt-1.5 font-mono-num`} value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })} />
            <span className="mt-1 block text-xs text-slate-400">{hint}</span>
          </label>
        ))}
        <button data-testid="save-fare-settings-button" className={primaryBtn}>Save settings</button>
      </form>
      <div className="h-fit rounded-2xl bg-[#0B192C] p-6 text-white sm:p-8 lg:col-span-2">
        <p className="text-xs font-bold uppercase tracking-widest text-blue-300">Example · 10 km trip</p>
        <p className="mt-3 font-mono-num text-4xl font-semibold" data-testid="fare-preview-amount">{kina(sample)}</p>
        <div className="mt-6 space-y-2 text-sm text-blue-100">
          <p className="flex justify-between"><span>Driver keeps</span><span className="font-mono-num">{kina(sample * (1 - form.driver_fee_pct / 100))}</span></p>
          <p className="flex justify-between"><span>Platform fee from driver</span><span className="font-mono-num text-amber-400">{kina(sample * form.driver_fee_pct / 100)}</span></p>
          <p className="flex justify-between"><span>Platform fee from Comfort Taxi</span><span className="font-mono-num text-amber-400">{kina(sample * form.company_fee_pct / 100)}</span></p>
        </div>
      </div>
    </div>
  );
};
